/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { HazardDto } from '../../models/hazard-dto';

export interface GetHazardsForRiskAssessment$Params {

/**
 * The customer id
 */
  customerId: number;

/**
 * The hazard factor id
 */
  hazardFactorId: number;
}

export function getHazardsForRiskAssessment(http: HttpClient, rootUrl: string, params: GetHazardsForRiskAssessment$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<HazardDto>>> {
  const rb = new RequestBuilder(rootUrl, getHazardsForRiskAssessment.PATH, 'get');
  if (params) {
    rb.path('customerId', params.customerId, {});
    rb.query('hazardFactorId', params.hazardFactorId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<HazardDto>>;
    })
  );
}

getHazardsForRiskAssessment.PATH = '/customers/{customerId}/hazards';
